import "./style.scss";
import * as React from "react";
import Feature from "../../../common/components/Feature";
import { Menu, Icon, Popover } from "antd";
import { SideMenuItemContents } from "../common";
import { withRouter } from "react-router-dom";
import {
  generateQueryString,
  parseQueryString
} from "../../../../modules/common/utils";
import {
  defaultGroupBy,
  defaultView,
  hasFinancePermissions
} from "../../../AnalyticsMetric/constants";
import { sendGAEvent, GAContextProps } from "../../../common/google_analytics";
import { DataExport } from "../DataExport";
import { AggregatedMetrics } from "../../constants";
import { MetricsSideMenuProps, MetricsSideMenuActions } from "./container";

class MetricsSideMenu extends React.Component<
  MetricsSideMenuProps &
    MetricsSideMenuActions &
    RouterChildProps &
    GAContextProps,
  {}
> {
  handleClick(e: any) {
    this.props.setMetricSelection(e.key, this.props.merchant_id);

    // Update the URL to reflect the new tab selection
    let queryProps = {
      ...parseQueryString(this.props.history.location.search),
      metric: e.key,
      group_by: defaultGroupBy(e.key, defaultView(e.key)),
      view: defaultView(e.key)
    };
    delete queryProps["compare_by"];
    const queryString = `?${generateQueryString(queryProps)}`;
    this.props.history.push(queryString);

    // GA beacon
    const { merchantName, gaUserContext, gaViewContext } = this.props;
    sendGAEvent("Analytics", "Metric Select", merchantName, {
      ...gaUserContext,
      ...gaViewContext
    });
  }

  round = (value: number) => Math.round(value * 100) / 100;
  formatNumber = (value: number, canBeUnavailable = false) => {
    if (canBeUnavailable && !value) return "Unavailable";

    return this.round(value).toLocaleString();
  };

  render() {
    const metrics = this.props.analytics_metrics;
    return (
      <div className="analytics-side-menu">
        <div
          className="analytics-menu-top-header"
          style={{ borderBottom: "1px solid #ddd", paddingBottom: 10 }}
        >
          &nbsp;
          <Icon type="area-chart" />
          &nbsp;
          <span style={{ fontSize: 16 }}>Publication Metrics</span>
        </div>
        {hasFinancePermissions(
          this.props.permissions,
          this.props.merchant_id
        ) ? (
          <Feature flag="spend_tab">
            <Menu
              style={{ width: 240 }}
              defaultSelectedKeys={[""]}
              selectedKeys={[this.props.metrics_container_tab]}
              mode="inline"
              onClick={this.handleClick.bind(this)}
              className="analytics-menu-cluster"
            >
              <Menu.Item key="spend" style={{ height: 50 }}>
                <SideMenuItemContents
                  metric="spend"
                  header="SPEND"
                  subheader={"$" + this.formatNumber(metrics.spend)}
                />
              </Menu.Item>
            </Menu>
          </Feature>
        ) : null}
        <div className="analytics-menu-header">
          <h3 style={{ fontSize: 16, color: "#5D6368", marginBottom: 0 }}>
            FUNNEL
          </h3>
          <div className="sub-header">Aggregate</div>
        </div>
        <Menu
          style={{ width: 240 }}
          defaultSelectedKeys={[""]}
          selectedKeys={[this.props.metrics_container_tab]}
          mode="inline"
          onClick={this.handleClick.bind(this)}
          className="analytics-menu-cluster"
        >
          <Menu.Item key="impressions" style={{ height: 50 }}>
            <SideMenuItemContents
              metric="impressions"
              header="IMPRESSIONS"
              subheader={this.formatNumber(metrics.impressions)}
            />
          </Menu.Item>
          <Menu.Item key="opens" style={{ height: 50 }}>
            <SideMenuItemContents
              metric="opens"
              header="OPENS"
              subheader={this.formatNumber(metrics.opens)}
            />
          </Menu.Item>
          <Menu.Item key="unique_engaged_visits" style={{ height: 50 }}>
            <SideMenuItemContents
              metric="unique_engaged_visits"
              header="UEV"
              subheader={this.formatNumber(metrics.unique_engaged_visits)}
            />
          </Menu.Item>
          <Menu.Item key="clicks" style={{ height: 50 }}>
            <SideMenuItemContents
              metric="clicks"
              header="TOTAL FLYER CLICKS"
              subheader={this.formatNumber(metrics.clicks)}
            />
          </Menu.Item>
          <Menu.Item key="shopping_list" style={{ height: 50 }}>
            <SideMenuItemContents
              metric="shopping_list"
              header="SHOPPING LIST"
              subheader={this.formatNumber(metrics.shopping_list)}
            />
          </Menu.Item>
          <Menu.Item key="ttm" style={{ height: 50 }}>
            <SideMenuItemContents
              metric="ttm"
              header="TRANSFER TO MERCHANT"
              subheader={this.formatNumber(metrics.ttm)}
            />
          </Menu.Item>
        </Menu>
        <div className="analytics-menu-header">
          <h3 style={{ fontSize: 16, color: "#5D6368", marginBottom: 0 }}>
            CONSUMER ENGAGEMENT
          </h3>
        </div>
        <Menu
          style={{ width: 240 }}
          defaultSelectedKeys={[""]}
          selectedKeys={[this.props.metrics_container_tab]}
          mode="inline"
          onClick={this.handleClick.bind(this)}
          className="analytics-menu-cluster"
        >
          <Menu.Item key="average_time_on_flyer" style={{ height: 50 }}>
            <SideMenuItemContents
              metric="average_time_on_flyer"
              header="AVG. TIME ON PUBLICATIONS"
              subheader={this.formatNumber(metrics.time_on_flyer) + "s"}
            />
          </Menu.Item>
          <Menu.Item key="item_views" style={{ height: 50 }}>
            <SideMenuItemContents
              metric="item_views"
              header="ITEM VIEWS"
              subheader={this.formatNumber(metrics.item_views)}
            />
          </Menu.Item>
        </Menu>
        <DataExport />
      </div>
    );
  }
}

export const supported_flyer_metrics: any = {
  impressions: true,
  opens: true,
  unique_engaged_visits: true,
  clicks: true,
  average_time_on_flyer: true,
  spend: true
};

export const supported_item_metrics: any = {
  shopping_list: true,
  item_views: true,
  ttm: true
};

export default MetricsSideMenu as any;



// WEBPACK FOOTER //
// ./client/modules/Analytics/components/MetricsSideMenu/component.tsx